import { render, staticRenderFns } from "./Edi.vue?vue&type=template&id=643c0f75&"
import script from "./Edi.vue?vue&type=script&lang=ts&"
export * from "./Edi.vue?vue&type=script&lang=ts&"
import style0 from "./Edi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports